"use client";

import { useRef, useState, MouseEvent, ReactNode } from "react";
import { m } from "framer-motion";

interface MagneticButtonProps {
    children: ReactNode;
    className?: string;
    intensity?: number;
    onClick?: () => void;
}

export function MagneticButton({
    children,
    className = "",
    intensity = 0.3,
    onClick
}: MagneticButtonProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
        if (!ref.current) return;

        const rect = ref.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const deltaX = (e.clientX - centerX) * intensity;
        const deltaY = (e.clientY - centerY) * intensity;

        setPosition({ x: deltaX, y: deltaY });
    };

    const handleMouseLeave = () => {
        setPosition({ x: 0, y: 0 });
    };

    return (
        <div
            ref={ref}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={onClick}
            className={`inline-block ${className}`}
        >
            <m.div
                animate={{ x: position.x, y: position.y }}
                transition={{
                    type: "spring",
                    stiffness: 150,
                    damping: 15,
                    mass: 0.1
                }}
            >
                {children}
            </m.div>
        </div>
    );
}
